import React, { useState } from 'react';

function Header({ isAuthenticated, onLogout, onLoginClick }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 w-full bg-wine shadow-lg" style={{ zIndex: 50 }}>
      <nav className="max-w-6xl mx-auto px-4 py-5 flex justify-between items-center">
        {/* Set in spaced caps to echo how the logo itself sets the name. It is a
            link, so it never inherited Playfair Display from the heading rule —
            hence the explicit font. Kept white: the gold mark is the one accent,
            and white holds 9.7:1 against the wine bar versus gold's 5.6:1. */}
        <a
          href="#home"
          className="text-white text-base md:text-xl font-bold flex items-center gap-3"
          style={{ fontFamily: "'Playfair Display', Georgia, serif", letterSpacing: '0.14em' }}
        >
          {/* The mark is decorative here: the name is already in the link text,
              so announcing it twice would just be noise. */}
          <img
            src="/logo-mark.png"
            alt=""
            aria-hidden="true"
            width="46"
            height="40"
            style={{ height: '2.5rem', width: 'auto' }}
          />
          VIVAT ALFA WINERY
        </a>
        
        {/* Desktop Menu */}
        <ul className="hidden lg:flex space-x-8 whitespace-nowrap text-white">
          <li><a href="#home" className="hover:text-gold transition">Home</a></li>
          <li><a href="#wines" className="hover:text-gold transition">Our Wines</a></li>
          <li><a href="#tastings" className="hover:text-gold transition">Tasting Room</a></li>
          <li><a href="#events" className="hover:text-gold transition">Events & News</a></li>
          <li><a href="#about" className="hover:text-gold transition">About</a></li>
          <li><a href="#contact" className="hover:text-gold transition">Contact</a></li>
        </ul>

        {/* Hamburger Button */}
        <button 
          onClick={toggleMenu}
          className="lg:hidden text-white focus:outline-none"
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isMenuOpen}
        >
          <svg 
            className="w-8 h-8" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            {isMenuOpen ? (
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M6 18L18 6M6 6l12 12" 
              />
            ) : (
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M4 6h16M4 12h16M4 18h16" 
              />
            )}
          </svg>
        </button>
      </nav>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="lg:hidden bg-wine-light">
          <ul className="flex flex-col space-y-2 px-4 py-4 text-white">
            <li>
              <a 
                href="#home" 
                className="block py-2 hover:text-gold transition"
                onClick={closeMenu}
              >
                Home
              </a>
            </li>
            <li>
              <a 
                href="#wines" 
                className="block py-2 hover:text-gold transition"
                onClick={closeMenu}
              >
                Our Wines
              </a>
            </li>
            <li>
              <a
                href="#tastings"
                className="block py-2 hover:text-gold transition"
                onClick={closeMenu}
              >
                Tasting Room
              </a>
            </li>
            <li>
              <a 
                href="#events" 
                className="block py-2 hover:text-gold transition"
                onClick={closeMenu}
              >
                Events & News
              </a>
            </li>
            <li>
              <a 
                href="#about" 
                className="block py-2 hover:text-gold transition"
                onClick={closeMenu}
              >
                About
              </a>
            </li>
            <li>
              <a 
                href="#contact" 
                className="block py-2 hover:text-gold transition"
                onClick={closeMenu}
              >
                Contact
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}

export default Header;